import 'core-js/actual';
import 'react-app-polyfill/ie11';
import '@fever/ui/theme.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { unregister } from 'registerServiceWorker';
import { IS_LOCAL_DEV, FEVER_API_ENDPOINT } from 'config/envVariable';
import dynamicImport from './dynamicImport';
import App from './App';
import { createScript, createTagManger, createPreconnect } from 'utils/createElement';
import generateCSP, { isClientFlow } from 'generateCSP';
import { createApiMonitor } from 'client/utils/initApiTimeoutMonitor';
import { setApiMonitor, clearApiMonitor } from 'api/client';

createPreconnect(
    FEVER_API_ENDPOINT,
    isClientFlow(window.location.pathname) ? 'anonymous' : 'use-credentials'
);

dynamicImport()
    .then(async () => {
        if (isClientFlow(window.location.pathname)) {
            // generateCSP 在開機階段就會取活動資訊（infos），且該請求會被 useInitPromo
            // 沿用（見 cacheBootPromoInfo / consumeBootPromoInfo）。useInitPromo 的監控是
            // 掛載後才設定的，攔不到這次 boot 請求，因此在此處包一層 boot 階段監控，
            // 讓 infos 逾時仍能被回報（與 useInitPromo 的 init 階段監控對稱）。
            const bootMonitor = createApiMonitor();
            setApiMonitor(bootMonitor);
            try {
                return await generateCSP();
            } finally {
                clearApiMonitor(bootMonitor);
            }
        }
    })
    .then(nonce => {
        const isEdit = window.location.pathname.indexOf('/edit') > 0;
        const feverGTM = isEdit ? 'GTM-WLQ8G7' : 'GTM-NP4F5B';
        createTagManger(feverGTM, nonce);
        createScript('//platform.instagram.com/en_US/embeds.js', nonce);
    })
    .then(() => initApp())
    .catch(() => initApp());

function initApp() {
    // Fix: createRoot() must only be called once per container.
    // Previously it was inside renderApp(), causing HMR to call createRoot()
    // on the same #root repeatedly, triggering the React warning:
    // "You are calling ReactDOMClient.createRoot() on a container that has
    // already been passed to createRoot() before."
    // Solution: create the root once, and only call root.render() on HMR updates.
    const container = document.getElementById('root');
    const root = createRoot(container);

    const renderApp = () => {
        root.render(<App />);
    };

    renderApp();
    unregister();

    if (IS_LOCAL_DEV && module.hot) {
        module.hot.accept('./App', renderApp);
    }
}
